<div class="row">
	<div class="col-md-12">
		<cache-date></cache-date>
	</div>
</div>

<hr/>


<div class="row">
	<div class="col-md-12">
		<period></period>
	</div>
</div>

<hr/>


<div>
	<div class="col-md-12">
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</div>
</div>

<hr/>

<div class="row">
	<div class="col-md-12">
		<ng-template #tipContent>
			* <strong>firstManual</strong> - воронка с заходами ниразу не плативших на страницы тарифа и оплаты и первая ручная оплата
			<br/>
			* <strong>secondManual</strong> - воронка с заходами хоть раз платившими и повторные ручные оплаты
			<br/>
			* <strong>firstAndSecondManual</strong> - воронка всех заходы и все ручные оплаты
		</ng-template>
		
		<switcher
			[options]="['firstManual', 'secondManual', 'firstAndSecondManual']"
			[ngbTooltip]="tipContent"
			(onChange)="onChartTypeChange($event)"
		></switcher>
	</div>
</div>

<div class="row">
	<div class="col-md-12">
		<chart [data]="chartData.data" [options]="chartData.options" [sextant]="'conversion-chart'"></chart>
	</div>
</div>

<div class="row">
	<div class="col-md-12">
		<chart [data]="chart2Data.data" [options]="chart2Data.options" [sextant]="'conversion-chart2'"></chart>
	</div>
</div>

<hr/>


<div class="row">
	<div class="col-md-12">
		<loading [isLoad]="paginationLoader"></loading>
		
		<ngb-pagination
			[extlinks]="links"
			[collectionSize]="pagination.pageCount"
			[maxSize]="10"
			[pageSize]="1"
			[(page)]="pagination.page"
			[boundaryLinks]="true"
			(pageChange)="onPageChange()"
			*ngIf="!paginationLoader && pagination.pageCount > 0"
		></ngb-pagination>
	</div>
</div>

<hr/>

<div class="row">
	<div class="col-md-12">
		<loading [isLoad]="statsLoader"></loading>
		<table class="table table-striped table-bordered" [sextant]="'stats'">
			<thead>
				<tr>
					<th>
						Дата визита
					</th>
					
					<th>
						{{ 'adminstat.yandex.tariffVisitCount' | translate }} / Уник
					</th>
					
					<th>
						{{ 'adminstat.yandex.paymentVisitCount' | translate }} / Уник
					</th>
					
					<th title="{{ 'adminstat.yandex.paymentVisitCount' | translate }} / {{ 'adminstat.yandex.tariffVisitCount' | translate }}">
						{{ 'adminstat.yandex.tariffAndPaymentConversion' | translate }} / Уник
					</th>
					
					<th>
						{{ 'adminstat.yandex.paidCount' | translate }}
					</th>
					
					<th title="{{ 'adminstat.yandex.paidCount' | translate }} / {{ 'adminstat.yandex.paymentVisitCount' | translate }}">
						{{ 'adminstat.yandex.paidAndPaymentConversion' | translate }} / Уник
					</th>
				</tr>
			</thead>
			
			<tbody class="js-container">
				<tr *ngFor="let stat of stats">
					<td>
						{{ stat.timestamp | dateFormat:'DD.MM.YYYY' }}
					</td>
					
					<td>
						{{ stat.tariffVisitCount }} / {{ stat.tariffVisitCountUniq }}
					</td>
					
					<td>
						{{ stat.paymentVisitCount }} / {{ stat.paymentVisitCountUniq }}
					</td>
					
					<td>
						{{ stat.tariffAndPaymentConversion | numberFormat: '1.2-2' }}% / {{ stat.tariffAndPaymentConversionUniq | numberFormat: '1.2-2' }}%
					</td>
					
					<td>
						{{ stat.paidCount }}
					</td>
					
					<td>
						{{ stat.paidAndPaymentConversion | numberFormat: '1.2-2' }}% / {{ stat.paidAndPaymentConversionUniq | numberFormat: '1.2-2' }}%
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>





